import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import React from 'react';
import { PickerOptionItem } from '../pages/types';

interface EntryRadioFieldProp {
  name: string;
  label: string;
  errors?: any;
  required?: boolean;
  register: (rules: any) => any;
  value?: any;
  visible?: boolean;
  optionItems?: PickerOptionItem[];
}
export default function EntryRadioField({
  name,
  label,
  errors = [],
  required = false,
  register,
  value,
  visible = true,
  optionItems = [],
}: EntryRadioFieldProp) {
  return visible && (
    <>
      <FormControl className="entry-field entry-radio" component="fieldset">
        <FormLabel htmlFor={name} component="legend">{label}</FormLabel>
        <RadioGroup
          id={name}
          name={name}
          defaultValue={value}
          row={true}
        >
          {optionItems.map(opt => (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              label={opt.label}
              control={<Radio inputRef={register({required})} />}
            />
          ))}
        </RadioGroup>
        {required && errors[name] && (
          <span className="entry-field-error">{`${label}を選択してください`}</span>
        )}
      </FormControl>
    </>
  );
}